import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NecToast } from '../../service/toast/toast.service';

@Component({
  selector: 'nec-single-input-dialog',
  templateUrl: './single-input-dialog.component.html',
  styleUrls: ['./single-input-dialog.component.scss']
})
export class NecSingleInputDialogComponent {

  @Input() display = false;
  @Input() header: string;
  @Input() inputValue: string;
  @Input() prompt: string;
  @Input() placeHolder: string;
  @Input() maxInputLength = 10;
  @Input() onUserCancelCleanInputValue = false;

  @Output() onUserConfirmEvent = new EventEmitter<string>();
  @Output() onUserCancelEvent = new EventEmitter();

  constructor(private toast: NecToast) {
  }

  /**
   * ç¡®å®è¾å¥åå®¹
   */
  confirm() {
    if (!this.inputValue || this.inputValue.length === 0) {
      this.toast.warning('è¯·è¾å¥åç±»åç§°');
      return;
    }
    this.onUserConfirmEvent.emit(this.inputValue);
  }

  cancel() {
    this.onUserCancelEvent.emit();
    if (this.onUserCancelCleanInputValue) {
      this.inputValue = '';
    }
  }

  /**
   * å³é­å¯¹è¯æ¡
   */
  hideDialog() {
    this.cancel();
    this.display = false;
  }

}
